module.exports = {
  mode: "jit",
  purge: ["./src/**/*.html", "./src/**/*.{js,jsx,ts,tsx}"],
  theme: {
    fontFamily: {
      frutiger: "frutiger",
      obligatov: "obligatov",
    },
    colors: {
      black: "#000000",
      white: "#ffffff",
      alpha: "#37348b",
      beta: "#29b8ce",
      backgroundColor: "#000000",
    },
  },
  variants: {
    extend: {},
  },
  plugins: [],
};
